import { SECURE_PASS_TAG_STATUS } from "@/utils/enum";
import { SECURE_PASS_TEXT } from "@/components/SecurePass/SecurePassText/SecurePassText";
export const SECURE_PASS_TAG_PROPS_MAP = {
    [SECURE_PASS_TAG_STATUS.Disabled]: {
        color: "rgb(217, 217, 217)",
        style: {
            cursor: "pointer",
            color: "rgb(120, 120, 120)",
            borderColor: "rgb(180, 180, 180)",
            borderWidth: 1,
        },
        title: "Disabled",
        toolTipText: `${SECURE_PASS_TEXT} validation will not be used`,
    },
    [SECURE_PASS_TAG_STATUS.MissingContact]: {
        color: "warning",
        style: {
            cursor: "pointer",
        },
        title: "Needs Info",
        toolTipText: "Pickup contact not set",
    },
    [SECURE_PASS_TAG_STATUS.FailedOutreach]: {
        color: "error",
        style: {
            cursor: "pointer",
        },
        title: "Failed Outreach",
        toolTipText: "Failed Outreach",
    },
    [SECURE_PASS_TAG_STATUS.FailedValidation]: {
        color: "error",
        style: {
            cursor: "pointer",
        },
        title: "Failed Validation",
        toolTipText: "Failed Validation",
    },
    [SECURE_PASS_TAG_STATUS.Enabled]: {
        color: "success",
        style: {
            cursor: "pointer",
        },
        title: "Enabled",
        toolTipText: `${SECURE_PASS_TEXT} validation will be used`,
    },
};
export const SECURE_PASS_TAG_STATUS_TO_BADGE_COLOR = {
    [SECURE_PASS_TAG_STATUS.Disabled]: "#d9d9d9",
    [SECURE_PASS_TAG_STATUS.MissingContact]: "#FAAD14",
    [SECURE_PASS_TAG_STATUS.FailedOutreach]: "red",
    [SECURE_PASS_TAG_STATUS.FailedValidation]: "red",
    [SECURE_PASS_TAG_STATUS.Enabled]: "#52C41A",
};
